import { useContext, useEffect } from "react";
import { UserStore } from "../..";
import BreadCrumbs from "../../components/breadcrumsb";
import { PageContainer } from "../../components/page";
import { runAuthHandler } from "../util";
import { useNavigate } from "react-router";
import AttractorCreator from "./AttractorCreator";
import { observer } from "mobx-react";

const PAGE_TITLE = "Create Kiosk Attractor";

const CreateKioskAttractorPage = () => {
  const navigate = useNavigate();
  const userStore = useContext(UserStore);
  const { selectedVenue } = userStore;

  useEffect(() => {
    runAuthHandler({ userStore, navigate });
  }, [selectedVenue]);

  return (
    <PageContainer>
      <BreadCrumbs
        routes={[
          { path: "/home", breadcrumbName: "Home" },
          { path: "/kiosk-attractors", breadcrumbName: "Kiosk Attractor" },
          {
            path: "/kiosk-attractors/create",
            breadcrumbName: "Create Kiosk Attractor",
          },
        ]}
      />
      <div className="text-3xl mb-6 text-center font-bold">{PAGE_TITLE}</div>
      <div className="w-full">
        <AttractorCreator />
      </div>
    </PageContainer>
  );
};

export default observer(CreateKioskAttractorPage);
